const normalizeCreativeRatingValue = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const formatGalleryContentEntriesFromResponse = (response) => {
  if (!response || typeof response !== "object") {
    return [];
  }

  return Object.keys(response)
    .sort((a, b) => response[b].creationTime - response[a].creationTime)
    .map((key) => {
      const entry = response[key];
      const base = {
        ...entry,
        id: key,
        rating: normalizeCreativeRatingValue(entry?.rating),
      };

      if (!Array.isArray(entry?.ratings)) {
        return base;
      }

      return {
        ...base,
        ratings: entry.ratings.map(normalizeCreativeRatingValue),
      };
    });
};

export const groupGalleryCarousels = (items) => {
  const result = [];

  items.forEach((item) => {
    if (item.type === "carousel" && Array.isArray(item.urls)) {
      const rawRatings = Array.isArray(item.ratings) ? item.ratings : [];
      const normalizedRatings = item.urls.map((_, index) =>
        normalizeCreativeRatingValue(rawRatings[index])
      );
      const firstRating =
        normalizedRatings.find(
          (rating) => typeof rating === "number" && Number.isFinite(rating)
        ) ?? normalizeCreativeRatingValue(item?.rating);

      const carouselImages = item.urls.map((url, index) => ({
        url,
        rating: normalizedRatings[index],
        id: `${item.id}-${index}`,
      }));

      result.push({
        ...item,
        isCarousel: true,
        carouselImages,
        url: carouselImages[0]?.url,
        rating: firstRating,
        ratings: normalizedRatings,
        id: item.id,
        creationTime: item.creationTime,
        creationTimeNegative: item.creationTimeNegative,
      });
      return;
    }

    result.push({
      ...item,
      rating: normalizeCreativeRatingValue(item?.rating),
    });
  });

  return result.sort((a, b) => {
    const timeA = a.creationTime || 0;
    const timeB = b.creationTime || 0;
    return timeB - timeA;
  });
};

export const isAIGeneratedGalleryItem = (item) => item?.isAIGenerated === true;

export const appendAIGeneratedGalleryContentsFromResponse = ({
  response,
  collected = [],
  limit,
}) => {
  const formatted = formatGalleryContentEntriesFromResponse(response);
  const grouped = groupGalleryCarousels(formatted);
  const collectedIds = new Set(collected.map((item) => item.id));
  const nextCollected = [...collected];

  for (const item of grouped) {
    if (!item?.url || !isAIGeneratedGalleryItem(item)) {
      continue;
    }

    if (collectedIds.has(item.id)) {
      continue;
    }

    nextCollected.push(item);
    collectedIds.add(item.id);

    if (nextCollected.length >= limit) {
      break;
    }
  }

  return nextCollected;
};
